export const moduloSchema = {
  fields: [
    {  
      name: 'codigo',
      type: 'text',
      label: 'Código',
      required: true,
      placeholder: 'ej: admin',
      gridSpan: 'auto',
      format: 'uppercase'
    },
    {
      name: 'nombre',
      type: 'text', 
      label: 'Nombre',
      required: true,
      placeholder: 'ej: Administración',
      gridSpan: 'auto'
    },
    {
      name: 'icono',
      type: 'text',
      label: 'Icono',
      required: true,
      placeholder: 'ej: users, settings, folder, circle',
      gridSpan: 'auto',
      defaultValue: 'circle'
    },
    {
      name: 'descripcion',
      type: 'textarea',
      label: 'Descripción',
      required: true,
      placeholder: 'ej: Gestión de administración',
      gridSpan: 'full'
    },
    {
      name: 'activo',
      type: 'checkbox',
      label: 'Módulo activo',
      required: false,
      gridSpan: 'full'
    },
  ]
};